import apiSlice from "./apiSlice";
const keyNcrSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addKeyNcr: builder.mutation({
      query: (body) => ({
        url: `ncr`,
        method: "POST",
        body,
      }),
    }),
    editKeyNcr: builder.mutation({
      query: ({ id, body }) => ({
        url: `ncr/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["GetAllNcrTag", "SubmittedByNcrTag"],
    }),
    deleteKeyNcr: builder.mutation({
      query: (id) => ({
        url: `ncr/${id}`,
        method: "DELETE",
      }),
    }),
    getPendingNcr: builder.query({
      query: (req) => ({
        url: `ncr/pending`,
        params: req,
      }),
      providesTags: ["PendingNcrTag"],
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getSubmittedByMeNcr: builder.query({
      query: (req) => ({
        url: `ncr/GetSubmittedNcr`,
        params: req,
      }),
      providesTags: ["SubmittedByNcrTag"],
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getKeyNcr: builder.query({
      query: (req) => ({
        url: `ncr/${req}`,
      }),
    }),
    updateWorkFlowNcr: builder.mutation({
      query: (body) => ({
        url: `ncr/UpdateWorkflow`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["PendingNcrTag", "SubmittedByNcrTag"],
    }),
    generateNcrOtp: builder.query({
      query: (req) => ({
        url: `ncr/GenrateOtp`,
        params: req,
      }),
    }),
    verifyNcrOtp: builder.mutation({
      query: (body) => ({
        url: `ncr/ValidateOtp`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useVerifyNcrOtpMutation,
  useGenerateNcrOtpQuery,
  useUpdateWorkFlowNcrMutation,
  useGetKeyNcrQuery,
  useAddKeyNcrMutation,
  useEditKeyNcrMutation,
  useDeleteKeyNcrMutation,
  useGetPendingNcrQuery,
  useGetSubmittedByMeNcrQuery,
} = keyNcrSlice;
